export const interpolateIntegerValue = (
	value: number,
	inputRange: [number, number],
	outputRange: [number, number],
): number => {
	const [inputMin, inputMax] = inputRange;
	const [outputMin, outputMax] = outputRange;
	const ratio = (value - inputMin) / (inputMax - inputMin);
	const interpolatedValue = Math.round(
		outputMin + ratio * (outputMax - outputMin),
	);
	return Math.min(Math.max(interpolatedValue, outputMin), outputMax);
};

export const snapToClosest = (value: number, snapPoints: number[]) => {
	return snapPoints.reduce((prev, curr) => {
		return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
	}, snapPoints[0]);
};
